interface TabItem {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export function Tabs({ tabs, activeTab, onTabChange, className = '' }: TabsProps) {
  return (
    <div className={`flex min-w-0 max-w-full flex-wrap border-b border-neutral-200 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`shrink-0 px-3 py-2 text-sm font-medium transition-colors sm:px-4 sm:py-3 ${
            activeTab === tab.id
              ? 'border-b-2 border-neutral-900 text-neutral-900'
              : 'text-neutral-500 hover:text-neutral-700'
          }`}
          onClick={() => onTabChange(tab.id)}
          type='button'
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
